// Inline CSS injection for Tricycle & Balance Bike menus
(function injectTricycleMenuStyle() {
  if (document.getElementById('tricycle-menu-inline-style')) return; // 防止重复注入

  const style = document.createElement('style');
  style.id = 'tricycle-menu-inline-style';
  style.textContent = `
    /* --- 仅 Tricycle & Balance Bike 菜单样式 --- */
    #NavigationTier2-2-mobMobileNav .nav-sections,
    #NavigationTier2-3-mobMobileNav .nav-sections { padding: 8px 0 12px; }

    #NavigationTier2-2-mobMobileNav .nav-thumb-section,
    #NavigationTier2-3-mobMobileNav .nav-thumb-section { padding: 0 16px; }

    #NavigationTier2-2-mobMobileNav .nav-thumb-section__header,
    #NavigationTier2-3-mobMobileNav .nav-thumb-section__header {
      display: flex; align-items: center; justify-content: space-between;
      padding: 12px 0 6px;
    }

    /* 标题文字稍小一点 */
    #NavigationTier2-2-mobMobileNav .nav-thumb-section__title,
    #NavigationTier2-3-mobMobileNav .nav-thumb-section__title {
      font-size: 17px; font-weight: 600; line-height: 1.2;
      text-decoration: none; color: inherit;
    }

    /* 右侧箭头变小、变浅 */
    #NavigationTier2-2-mobMobileNav .nav-thumb-section__chev,
    #NavigationTier2-3-mobMobileNav .nav-thumb-section__chev {
      font-size: 10px; line-height: 1; text-decoration: none;
      color: #a5a5a5; padding-left: 4px;
    }

    #NavigationTier2-2-mobMobileNav .nav-thumb-row,
    #NavigationTier2-3-mobMobileNav .nav-thumb-row {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      gap: 12px;
      margin: 0; padding: 0; list-style: none;
    }

    @media (max-width: 360px) {
      #NavigationTier2-2-mobMobileNav .nav-thumb-row,
      #NavigationTier2-3-mobMobileNav .nav-thumb-row {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
    }

    #NavigationTier2-2-mobMobileNav .nav-thumb-row__link,
    #NavigationTier2-3-mobMobileNav .nav-thumb-row__link {
      display: block; text-decoration: none;
    }

    #NavigationTier2-2-mobMobileNav .nav-thumb-row__img,
    #NavigationTier2-3-mobMobileNav .nav-thumb-row__img {
      aspect-ratio: 1 / 1; border-radius: 10px; overflow: hidden;
      background: #f7f7f7;
    }

    #NavigationTier2-2-mobMobileNav .nav-thumb-row__img img,
    #NavigationTier2-3-mobMobileNav .nav-thumb-row__img img {
      width: 100%; height: 100%; object-fit: cover; display: block;
    }

    #NavigationTier2-2-mobMobileNav .nav-thumb-divider,
    #NavigationTier2-3-mobMobileNav .nav-thumb-divider {
      border: 0; height: 1px; background: rgba(0,0,0,0.06);
      margin: 14px 0;
    }
  `;
  document.head.appendChild(style);
})();



(function () {
    'use strict';
   function fixEmptyMegaMenus() {
  console.debug('[mobile-mega] fixEmptyMegaMenus() start');

  // —— 工具函数 —— //
  function pickSrcFromImg(imgEl) {
    try {
      if (!imgEl) return '';
      if (imgEl.currentSrc) return imgEl.currentSrc;
      const srcset = imgEl.getAttribute('srcset') || '';
      if (srcset) {
        const parts = srcset.split(',').map(s => s.trim());
        let best = '', bestScore = Infinity, target = 600;
        parts.forEach(p => {
          const m = p.match(/(\S+)\s+(\d+)w/);
          if (m) {
            const url = m[1]; const w = parseInt(m[2], 10);
            const score = Math.abs(w - target);
            if (score < bestScore) { bestScore = score; best = url; }
          }
        });
        if (best) return best;
      }
      return imgEl.getAttribute('src') || '';
    } catch (e) { console.error('[mobile-mega] pickSrcFromImg error', e); return ''; }
  }
  function getHandleFromUrl(url) {
    try {
      const a = document.createElement('a'); a.href = url;
      const m = a.pathname.match(/\/collections\/([^\/]+)/i);
      return m ? m[1] : '';
    } catch { return ''; }
  }
  // —— 工具函数结束 —— //

  // 仅在白名单中的菜单上启用（请确认为“Tricycle / Balance Bike”的真实 ID）
  const ALLOWED_MOBILE_IDS = [
    'NavigationTier2-2-mobMobileNav', // Tricycle
    'NavigationTier2-3-mobMobileNav', // Balance Bike
  ];

  const mobileContainers = Array.from(
    document.querySelectorAll('.navigation__tier-2-container[id*="mobMobileNav"]')
  ).filter(c => ALLOWED_MOBILE_IDS.includes(c.id));

  console.debug('[mobile-mega] mobileContainers:', mobileContainers.length);

  mobileContainers.forEach((container) => {
    try {
      const mobileId = container.id;
      const tier2 = container.querySelector('.navigation__tier-2');
      if (!tier2) return;

      // 已存在分区则不重复构建
      if (tier2.querySelector('.nav-sections')) {
        console.debug('[mobile-mega] sections already exist, skip:', mobileId);
        return;
      }

      // 通过 ID 找到对应桌面容器
      const desktopId = mobileId.replace('-mobMobileNav', '');
      const desktopContainer = document.querySelector(`#${desktopId}`);
      console.debug('[mobile-mega] map desktop:', { mobileId, desktopId, found: !!desktopContainer });
      if (!desktopContainer) return;

      // 1) 收集“左侧文本菜单项”（从桌面容器抓，排除预览列）
      let menuItems = [];
      const desktopTier2 = desktopContainer.querySelector('.navigation__tier-2');
      if (desktopTier2) {
        const links = desktopTier2.querySelectorAll(
          '.navigation__column:not(.navigation__column--main-product-preview) .navigation__link, .navigation__link'
        );
        links.forEach(l => {
          const text = (l.textContent || '').trim();
          const url  = l.href;
          const isPrev = !!l.closest('.navigation__column--main-product-preview') ||
                         !!l.closest('.navigation__main-product-preview');
          const isMore = text === 'View More' || text === 'View All';
          if (text && url && !isPrev && !isMore) {
            if (!menuItems.some(x => x.url === url)) menuItems.push({ text, url });
          }
        });
      }
      console.debug('[mobile-mega] menuItems:', menuItems);

      // 兜底：太少则补默认集合
      if (menuItems.length <= 1) {
        const u = menuItems.map(i => i.url);
        [
          { text: 'All Tricycle', url: '/collections/tricycle' },
          { text: 'Kids Tricycle', url: '/collections/kids-tricycles' },
          { text: 'Adult Tricycle', url: '/collections/adult-tricycles' },
          { text: 'Electric Tricycle', url: '/collections/electric-tricycles' }
        ].forEach(i => { if (!u.includes(i.url)) menuItems.push(i); });
        console.debug('[mobile-mega] appended defaults:', menuItems);
      }

      // 2) 收集桌面“预览列”中的所有产品卡（根据你提供的 DOM）
      const previewRoot =
        desktopContainer.querySelector('.navigation__main-product-preview') ||
        desktopContainer.querySelector('.navigation__column--main-product-preview');

      let allTiles = [];
      if (previewRoot) {
        // 结构：.image-cont a.product-link img.theme-img
        const tileLinks = Array.from(previewRoot.querySelectorAll('.image-cont a.product-link'));
        allTiles = tileLinks.map(a => {
          const imgEl = a.querySelector('img.theme-img');
          return { href: a.href, img: pickSrcFromImg(imgEl) };
        }).filter(t => t.img);
      }
      console.debug('[mobile-mega] desktop tiles:', allTiles.length);

      // 3) 为每个集合匹配多张图片：优先匹配含该 collection handle 的产品；不够则补其它图片
      const sectionsData = menuItems.map(mi => {
        const handle = getHandleFromUrl(mi.url);
        let pics = [];
        if (handle) {
          pics = allTiles.filter(t => t.href.includes(`/collections/${handle}/`));
        }
        if (pics.length < 4) {
          const extra = allTiles.filter(t => !pics.includes(t)).slice(0, 4 - pics.length);
          pics = pics.concat(extra);
        } else {
          pics = pics.slice(0, 4);
        }
        return { title: mi.text, href: mi.url, pics };
      });
      console.debug('[mobile-mega] sectionsData:', sectionsData);

      // 4) 构建分区 DOM：标题 + 右箭头(SVG) + 图片行 + 分隔线（仅保留分区）
      const sectionsWrap = document.createElement('div');
      sectionsWrap.className = 'nav-sections';

      sectionsData.forEach(sec => {
        const section = document.createElement('section');
        section.className = 'nav-thumb-section';

        // 标题行（标题和箭头都可点击；箭头使用 SVG）
        section.innerHTML = `
          <div class="nav-thumb-section__header">
            <a class="nav-thumb-section__title" href="${sec.href}" data-mobile-nav-close>${sec.title}</a>
            <a class="navigation__children-toggle" href="${sec.href}" aria-label="Show links">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-right" aria-hidden="true" focusable="false" role="presentation">
                    <path d="m6 9 6 6 6-6"></path>
                </svg>
            </a>
          </div>
          <ul class="nav-thumb-row" role="list"></ul>
          <hr class="nav-thumb-divider" />
        `;

        const row = section.querySelector('.nav-thumb-row');

        sec.pics.forEach(p => {
          const li = document.createElement('li');
          li.className = 'nav-thumb-row__item';
          li.innerHTML = `
            <a class="nav-thumb-row__link" href="${sec.href}" data-mobile-nav-close>
              <div class="nav-thumb-row__img">${p.img ? `<img loading="lazy" alt="${sec.title}">` : ''}</div>
            </a>
          `;
          const img = li.querySelector('img');
          if (img && p.img) img.src = p.img;
          row.appendChild(li);
        });

        sectionsWrap.appendChild(section);
      });

      // 仅保留我们生成的分区（去掉底部文本列表）
      tier2.innerHTML = '';
      tier2.appendChild(sectionsWrap);
      console.debug('[mobile-mega] inserted sections ONLY into', mobileId);

      // 5) 绑定点击关闭
      setTimeout(() => {
        try { initMobileThumbnails(); } catch (e) { console.error(e); }
      }, 0);

      // 6) 确保容器可见
      container.style.display = 'block';

    } catch (e) {
      console.error('[mobile-mega] container build error:', e);
    }
  });

  console.debug('[mobile-mega] fixEmptyMegaMenus() end');
}




    // function fixEmptyMegaMenus() {
    //     // 查找移动端容器
    //     const mobileContainers = document.querySelectorAll('.navigation__tier-2-container[id*="mobMobileNav"]');

    //     mobileContainers.forEach(function (container) {
    //         // 检查容器是否包含产品预览（表示这是一个mega menu）
    //         const hasProductPreview = container.querySelector('.navigation__column--main-product-preview');

    //         if (hasProductPreview) {
    //             const tier2 = container.querySelector('.navigation__tier-2');
    //             if (!tier2) return;

    //             // 检查现有的菜单项（排除产品预览）
    //             const existingItems = tier2.querySelectorAll('.navigation__item:not(.navigation__column--main-product-preview)');

    //             // 检查是否已经有新的移动端产品缩略图结构
    //             const hasMobileThumbnails = tier2.querySelector('.navigation__mobile-menu-with-thumbnails');

    //             // 如果只有产品预览，没有实际菜单项，且没有移动端缩略图结构
    //             if (existingItems.length === 0 && !hasMobileThumbnails) {
    //                 // 隐藏产品预览
    //                 const productPreview = tier2.querySelector('.navigation__column--main-product-preview');
    //                 if (productPreview) {
    //                     console.log('mobile-2')
    //                     productPreview.style.display = 'none';
    //                 }

    //                 // 获取当前移动端容器的ID，找到对应的桌面端容器
    //                 const mobileId = container.id;
    //                 const desktopId = mobileId.replace('-mobMobileNav', '');
    //                 const desktopContainer = document.querySelector(`#${desktopId}`);
    //                 let realMenuItems = [];

    //                 if (desktopContainer) {
    //                     const desktopTier2 = desktopContainer.querySelector('.navigation__tier-2');

    //                     if (desktopTier2) {
    //                         // 直接查找所有菜单链接，排除产品预览列
    //                         const menuLinks = desktopTier2.querySelectorAll('.navigation__column:not(.navigation__column--main-product-preview) .navigation__link');

    //                         menuLinks.forEach(function (link) {
    //                             const linkText = link.textContent.trim();
    //                             const linkUrl = link.href;

    //                             if (linkText && linkText !== 'View More' && linkText !== 'View All') {
    //                                 realMenuItems.push({
    //                                     text: linkText,
    //                                     url: linkUrl
    //                                 });
    //                             }
    //                         });

    //                         // 尝试查找所有链接，不管层级
    //                         if (realMenuItems.length <= 1) {
    //                             const allLinks = desktopTier2.querySelectorAll('a');

    //                             allLinks.forEach(function (link) {
    //                                 const linkText = link.textContent.trim();
    //                                 const linkUrl = link.href;
    //                                 const isProductPreview = link.closest('.navigation__column--main-product-preview');
    //                                 const isViewMore = linkText === 'View More' || linkText === 'View All';

    //                                 if (linkText && !isProductPreview && !isViewMore) {
    //                                     // 检查是否已经存在
    //                                     const exists = realMenuItems.some(item => item.text === linkText);
    //                                     if (!exists) {
    //                                         realMenuItems.push({
    //                                             text: linkText,
    //                                             url: linkUrl
    //                                         });
    //                                     }
    //                                 }
    //                             });
    //                         }
    //                     }
    //                 }

    //                 // 如果只找到一个菜单项或没有找到，添加更多默认项
    //                 if (realMenuItems.length <= 1) {
    //                     // 保留已找到的项目，然后添加更多
    //                     const existingUrls = realMenuItems.map(item => item.url);

    //                     const additionalItems = [
    //                         { text: 'All Tricycle', url: '/collections/tricycle' },
    //                         { text: 'Kids Tricycle', url: '/collections/kids-tricycles' },
    //                         { text: 'Adult Tricycle', url: '/collections/adult-tricycles' },
    //                         { text: 'Electric Tricycle', url: '/collections/electric-tricycles' }
    //                     ];

    //                     // 只添加不重复的项目
    //                     additionalItems.forEach(item => {
    //                         if (!existingUrls.includes(item.url)) {
    //                             realMenuItems.push(item);
    //                         }
    //                     });
    //                 }

    //                 // 清空tier-2内容并重新构建
    //                 tier2.innerHTML = '';
    //                 tier2.style.cssText = `
    //                     display: block !important;
    //                     flex-direction: column !important;
    //                     padding: 0 !important;
    //                     background: transparent !important;
    //                     list-style: none !important;
    //                     margin: 0 !important;
    //                 `;

    //                 realMenuItems.forEach(function (item) {
    //                     // 创建菜单项
    //                     const menuItem = document.createElement('li');
    //                     menuItem.className = 'navigation__item';
    //                     menuItem.style.cssText = `
    //                         display: block !important;
    //                         width: 100% !important;
    //                         margin: 0 !important;
    //                         padding: 0 !important;
    //                     `;

    //                     // 创建链接
    //                     const link = document.createElement('a');
    //                     link.className = 'navigation__link';
    //                     link.href = item.url;
    //                     link.textContent = item.text;
    //                     link.style.cssText = `
    //                         display: block !important;
    //                         padding: 12px 20px !important;
    //                         font-size: inherit !important;
    //                         color: inherit !important;
    //                         text-decoration: none !important;
    //                         background: transparent !important;
    //                         border: none !important;
    //                         transition: all 0.2s ease !important;
    //                     `;

    //                     // 组装
    //                     menuItem.appendChild(link);
    //                     tier2.appendChild(menuItem);
    //                 });

    //                 // 确保容器可见
    //                 container.style.display = 'block';
    //             } else if (hasMobileThumbnails) {
    //                 // 如果已经有移动端缩略图结构，确保容器可见但不重建
    //                 container.style.display = 'block';
    //                 // 隐藏桌面端产品预览
    //                 const productPreview = tier2.querySelector('.navigation__column--main-product-preview');
    //                 if (productPreview) {
    //                     productPreview.style.display = 'none';
    //                 }
    //             }
    //         }
    //     });
    // }

    // 监听Mega菜单点击
    function observeMegaMenuClick() {
        document.addEventListener('click', function (e) {
            const menuItem = e.target.closest('.navigation__item');
            if (menuItem) {
                const menuLink = menuItem.querySelector('.navigation__link');
                if (menuLink) {
                    // 检查是否是有产品预览的菜单项
                    const hasProductPreview = menuItem.closest('.navigation__tier-1').querySelector('.navigation__item--with-main-product-preview');
                    if (hasProductPreview) {
                        setTimeout(fixEmptyMegaMenus, 100);
                        setTimeout(fixEmptyMegaMenus, 300);
                    }
                }
            }
        });
    }

    // 监听移动端导航打开
    function observeMobileNavigation() {
        const mobileNavDrawer = document.querySelector('.mobile-navigation-drawer');

        if (mobileNavDrawer) {
            const observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        if (mobileNavDrawer.classList.contains('mobile-navigation-drawer--open')) {
                            setTimeout(fixEmptyMegaMenus, 200);
                        }
                    }
                });
            });

            observer.observe(mobileNavDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    // 移动端产品缩略图功能
    function initMobileThumbnails() {
        // 处理移动端产品缩略图的自动关闭导航功能
        const thumbnailLinks = document.querySelectorAll('[data-mobile-nav-close]');
        console.log('loading mobile')
        thumbnailLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                // 添加点击反馈效果
                addClickFeedback(link);

                // 延迟关闭导航，让用户看到点击效果
                setTimeout(function () {
                    closeMobileNavigation();
                }, 100);
            });

            // 添加触摸优化
            link.addEventListener('touchstart', function (e) {
                link.style.opacity = '0.7';
                link.style.transform = 'scale(0.95)';
            });

            link.addEventListener('touchend', function (e) {
                setTimeout(function () {
                    link.style.opacity = '';
                    link.style.transform = '';
                }, 150);
            });
        });
    }

    function addClickFeedback(element) {
        // 添加视觉反馈
        element.style.opacity = '0.7';
        element.style.transform = 'scale(0.95)';
        element.style.transition = 'all 0.1s ease';

        setTimeout(function () {
            element.style.opacity = '';
            element.style.transform = '';
        }, 150);
    }

    function closeMobileNavigation() {
        // 查找并关闭移动端导航菜单
        const mobileNav = document.querySelector('.mobile-navigation-drawer');
        const body = document.body;
        const mobileNavToggle = document.querySelector('[data-mobile-nav-toggle]');

        if (mobileNav && body.classList.contains('mobile-navigation-open')) {
            // 移除打开状态的类
            body.classList.remove('mobile-navigation-open');

            // 设置导航为隐藏状态
            mobileNav.setAttribute('aria-hidden', 'true');

            // 如果有切换按钮，更新其状态
            if (mobileNavToggle) {
                mobileNavToggle.setAttribute('aria-expanded', 'false');
            }

            // 恢复页面滚动
            body.style.overflow = '';

            // 触发自定义事件，通知其他组件导航已关闭
            const closeEvent = new CustomEvent('mobileNavigationClosed', {
                bubbles: true,
                detail: { source: 'productThumbnail' }
            });
            document.dispatchEvent(closeEvent);
        }
    }

    // 初始化
    function init() {
        fixEmptyMegaMenus();
        observeMegaMenuClick();
        observeMobileNavigation();
        initMobileThumbnails();
    }

    // 监听DOM变化，重新初始化移动端缩略图功能
    function observeContentChanges() {
        const mobileNavDrawer = document.querySelector('.mobile-navigation-drawer');

        if (mobileNavDrawer) {
            const observer = new MutationObserver(function (mutations) {
                let shouldReinit = false;

                mutations.forEach(function (mutation) {
                    if (mutation.type === 'childList') {
                        // 检查是否有新的产品缩略图添加
                        mutation.addedNodes.forEach(function (node) {
                            if (node.nodeType === 1) { // Element node
                                const hasThumbnails = node.querySelector && node.querySelector('[data-mobile-nav-close]');
                                if (hasThumbnails) {
                                    shouldReinit = true;
                                }
                            }
                        });
                    }
                });

                if (shouldReinit) {
                    setTimeout(initMobileThumbnails, 100);
                }
            });

            observer.observe(mobileNavDrawer, {
                childList: true,
                subtree: true
            });
        }
    }

    // 启动
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
            observeContentChanges();
        });
    } else {
        init();
        observeContentChanges();
    }

    window.addEventListener('load', function () {
        setTimeout(function () {
            init();
            initMobileThumbnails(); // 确保页面完全加载后重新初始化
        }, 500);
    });

})();